// Appointment times for the customer, in their own locale.

const localeOf = lng => ({ de: "de-DE", en: "en-GB", tr: "tr-TR", ar: "ar" })[lng] || "de-DE";

const day = (date, lng) =>
  date.toLocaleDateString(localeOf(lng), {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
const clock = (date, lng) =>
  date.toLocaleTimeString(localeOf(lng), { hour: "2-digit", minute: "2-digit" });

const valid = value => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

/** "Mo., 12.10.2026, 08:00 – 10:00" */
export const rangeText = (startValue, endValue, lng) => {
  const start = valid(startValue);
  if (!start) return "";
  const end = valid(endValue);
  return `${day(start, lng)}, ${clock(start, lng)}${end ? ` – ${clock(end, lng)}` : ""}`;
};

export const appointmentText = (appointment, lng) =>
  rangeText(appointment.start, appointment.end, lng);

/** A proposed slot: its instants when stored, else the date and times as typed. */
export const slotText = (slot, lng) => {
  if (valid(slot.start)) return rangeText(slot.start, slot.end, lng);
  const date = valid(slot.date);
  const times = [slot.startTime, slot.endTime].filter(Boolean).join(" – ");
  return [date ? day(date, lng) : slot.date, times].filter(Boolean).join(", ");
};
